import { useDeleteCustomer } from "api/customers/service";
import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
const { CardBody, Table, Button, Modal, ModalBody } = require("reactstrap");

const DealApplicantReferences = ({ permissions, data = [], isLoading }) => {
    const { t } = useTranslation();
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [selectedDeleteId, setSelectedDeleteId] = useState(null);
    
    const handleDeleteSuccess = useCallback(() => {
        setDeleteModalOpen(false);
        setSelectedDeleteId(null);
    }, []);
    
    const deleteCustomerMutation = useDeleteCustomer({
        onSuccess: handleDeleteSuccess
    });

    const handleDeleteReference = (id) => {
        setDeleteModalOpen(true);
        setSelectedDeleteId(id);

    }
    const handleCancelDelete = () => {
        setDeleteModalOpen(false);
        setSelectedDeleteId(null);
      };



  const handleConfirmDelete = () => {
    if (selectedDeleteId) {
        deleteCustomerMutation.mutate(selectedDeleteId, {
        onSuccess: () => {
          setDeleteModalOpen(false);
          setSelectedDeleteId(null);
        }
      });
    }
  };
    return (
        <div>
            <CardBody>
                {isLoading ? (
                    <div>{t('common.loading')}</div>
                ) : !data || data.length === 0 ? (
                    <h5>{t('dealApplicantTab.noReferencesFound')}</h5>
                ) : (
                    <Table responsive>
                        <thead className="text-primary">
                            <tr>
                                <th>{t('dealApplicantTab.name')}</th>
                                <th>{t('dealApplicantTab.relation')}</th>
                                <th className="text-center">{t('dealApplicantTab.email')}</th>
                                <th className="text-center">{t('dealApplicantTab.homePhone')}</th>
                                <th className="text-center">{t('dealApplicantTab.cellPhone')}</th>
                                <th className="text-center">{t('dealApplicantTab.workPhone')}</th>
                                <th className="text-center">{t('dealApplicantTab.actions')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((reference, index) => (
                                <tr key={index}>
                                    <td>{reference.full_name}</td>
                                    <td>{reference.relationship_type}</td>
                                    <td className="text-center">{reference.email || "-"}</td>
                                    <td className="text-center">{reference.home_phone || "-"}</td>
                                    <td className="text-center">{reference.cell_phone || "-"}</td>
                                    <td className="text-center">{reference.work_phone || "-"}</td>
                                    <td className="text-center">
                                        <Button
                                            size="sm"
                                            className="btn-icon btn-link like"
                                            color="danger"
                                            onClick={() => handleDeleteReference(reference.documentId)}>
                                            <i className="tim-icons icon-simple-remove"></i>
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}

            </CardBody>
            <Modal isOpen={deleteModalOpen} toggle={handleCancelDelete}centered={false} style={{ marginTop: '100px' }}>
                <div className="modal-header justify-content-center">
                    <button
                        aria-hidden={true}
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={handleCancelDelete}
                    >
                        <i className="tim-icons icon-simple-remove" />
                    </button>
                    <h6 className="title title-up">{t('dealApplicantTab.deleteReference')}</h6>
                </div>
                <ModalBody className="text-center">
                    <p>{t('dealApplicantTab.areYouSureDeleteReference')}</p>
                </ModalBody>
                <div className="modal-footer">
                    <Button
                        color="secondary"
                        type="button"
                        onClick={handleCancelDelete}
                        disabled={deleteCustomerMutation.isPending}
                    >
                        {t('common.cancel')}
                    </Button>
                    <Button
                       style={{
                        background: 'linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93)',
                        backgroundImage: 'linear-gradient(to bottom left, #fd5d93, #ec250d, #fd5d93)',
                        borderColor: '#fd5d93',
                        color: 'white'
                    }}
                        color="danger"
                        type="button"
                        onClick={handleConfirmDelete}
                        disabled={deleteCustomerMutation.isPending}
                    >
                        {deleteCustomerMutation.isPending ? (
                            <>
                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                {t('dealApplicantTab.deleting')}
                            </>
                        ) : (
                            t('dealApplicantTab.yesDelete')
                        )}
                    </Button>
                </div>
            </Modal>
        </div>
    )
}

export default DealApplicantReferences;